import axios from 'axios';
import BaseAPI from '~/api/_BaseAPI';

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();

  const $axios = axios.create({
    baseURL: runtimeConfig.public.apiBaseUrl + '/api/web',
    headers: {
      'Accept': 'application/json',
    },
    withCredentials: true,
    timeout: (process.env.NODE_ENV === 'production' ? 30 : 600) * 1000,
  });

  // todo
  // const laravelEcho = new Echo({
  //   broadcaster: 'pusher',
  //   Pusher,
  //   key: runtimeConfig.public.pusherAppKey,
  //   wsHost: runtimeConfig.public.pusherHost,
  //   wsPort: 80,
  //   wssPort: 443,
  //   cluster: 'eu', // any value
  //   forceTLS: true,
  //   encrypted: true,
  //   disableStats: true,
  //   enabledTransports: ['wss'],
  //   withoutInterceptors: true,
  // });
  //
  // $axios.interceptors.request.use((config) => {
  //   if (laravelEcho.socketId()) {
  //     logger().debug({ 'X-Socket-Id': laravelEcho.socketId() });
  //     config.headers['X-Socket-Id'] = laravelEcho.socketId();
  //   }
  //
  //   return config;
  // });
  //
  // setLaravelEcho(laravelEcho);

  BaseAPI.init($axios);
});
